export function isLocal(){
    /*basic check checking if we're live or local
    This is for bgImage path issue hacks and CORS issues
    All other modules can now just test if(!isLocal)
    */
    const currentURL = window.location.href;
    const urlTest = "webnamehere.com";
    
    if(currentURL.indexOf(urlTest) !== -1){
        localStorage.setItem("routeBase", "/jarvis");
        return false;
    }else{
        localStorage.setItem("routeBase", "");
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/components/includes/behindTheScenes/devLiveCheck.js